// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.518Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone'
})(this, function (m_module, Backbone) {

var M = m_module.M;

"use strict";

  M.Model = M.Model || {};
  M.Model.DeliveryEstimator = M.Model.DeliveryEstimator || {};

  /**
   * LineItem model for the new delivery estimator javascript api library
   */
  M.Model.DeliveryEstimator.LineItem = Backbone.Model.extend({

    defaults: function() {
      return {
        'sku': '',
        'product_kind': '',
        'is_sample': false,
        'is_express_service': false,
        'die_cut': false
      }
    }

  });

return {
};

});

